/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown>, year: NonNullable<unknown> }} Sub_Billing_ExpiresInputs */



/**
* | output |
* | --- |
* | "Expires {month}/{year}" |
*
* @param {Sub_Billing_ExpiresInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_billing_expires = /** @type {((inputs: Sub_Billing_ExpiresInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Billing_ExpiresInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Läuft ab ${i?.month}/${i?.year}`)
	return /** @type {LocalizedString} */ (`Expires ${i?.month}/${i?.year}`)
});